import Image from "next/image";

function LogoIcon() {
    const image_loader = ({ src }) => {
        return src;
    };

    return (
        <Image
            src="/assets/images/ai-agent.png"
            alt="Shadow Detect"
            width="100"
            height="100"
            loader={image_loader}
            unoptimized={true}
            className="rounded-full"
        />
    );
}

export default LogoIcon;
